/**
 * FlowupLabels - Vanilla JS replacement (no jQuery dependency)
 * Adds 'focused'/'populated' classes to form containers on focus/blur
 */
function runFlowup() {
  var selectors = 'form.registerform, form.loginform, form#contact_form';
  var forms = document.querySelectorAll(selectors);
  if (!forms.length) return;

  forms.forEach(function(form) {
    var inputs = form.querySelectorAll('.input-text, .form-control');

    inputs.forEach(function(input) {
      input.addEventListener('focus', function() {
        var parent = this.closest('.form-row, .form-group, .floating_input');
        if (parent) parent.classList.add('focused');
      });

      input.addEventListener('blur', function() {
        var parent = this.closest('.form-row, .form-group, .floating_input');
        if (!parent) return;
        if (this.value.length) {
          parent.classList.add('populated');
          parent.classList.remove('focused');
        } else {
          parent.classList.remove('populated', 'focused');
        }
      });

      // Init: trigger blur logic for pre-filled inputs
      if (input.value && input.value.length) {
        var parent = input.closest('.form-row, .form-group, .floating_input');
        if (parent) parent.classList.add('populated');
      }
    });
  });
}
